<template>
    <div id="home">
        <img class="saabLogo" src="@/assets/images/saab-logo-blue.svg" @click="$root.toggleFullscreen()">
        <TitleBlock
        primaryTitle="All communication<br>– any application"
        primarySubtitle="DEPLOYABLE COMMUNICATION &#38;<br> INFORMATION SYSTEM (DCIS)"
        secondaryContent="A rapidly deployed modular and scalable communications solution that can integrate with any existing system, during any mission, in any&nbsp;terrain."
        @buttonPulseClick="nextPage"
        />
    </div>
</template>

<script>
// @ is an alias to /src
import TitleBlock from '@/components/TitleBlock'

export default {
    name: 'home',
    components: {
        TitleBlock,
    },
    methods: {
        nextPage() {
            this.$router.push({name: 'intro'})
        },
        handleKeys(e) {
            switch (e.keyCode) {
                case 13: // return/enter 
                    this.nextPage()
                break;
            }
        }
    },
    mounted() {
        document.addEventListener('keydown', this.handleKeys)
    },
    beforeDestroy() {
        document.removeEventListener('keydown', this.handleKeys)
    },
}
</script>

<style lang="scss" scoped>

#home {
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100vw;
    padding: $menuHeight;
    padding: 3rem;
    text-align: left;
    background-image: url('../assets/images/top_level_backgrounds/home-background.jpg');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    .saabLogo {
        width: 20rem;
        display: block;
        margin-bottom: 3rem;
    }
}

.titleBlock {
    // margin-left: 4.2rem;
}

</style>
